import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  AuthenticationService,
  DataService,
  LoansService,
  OperationsService,
  OptionsserviceService,
  StorageService
} from '../../_services/index';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-investmentdetails',
  templateUrl: './investmentdetails.component.html',
  styleUrls: ['./investmentdetails.component.css', './style.css', './boot-outline-btn.css']
})
export class InvestmentdetailsComponent implements OnInit {
  currentUser: any;
  parentRouteId: any;
  sub: any;
  investment:any;
  loading = false;
  constructor(private DataService: DataService,
    public toastr: ToastrService,public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public authService: AuthenticationService,
    public router: Router) {
    this.currentUser = this.storageService.read<any>('currentUser'); 
  } 
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }

  ngOnInit() {
    this.getSummary();
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      //this.getLoan();
    });

  }
}
